export interface FlagDto {
  id: string;
  reporterId: string;
  reporterUsername: string;
  reporterTier: string;
  reporterAmmoScore: number;
  reporterFlagsSubmitted: number;
  reporterFlagsUpheld: number;
  targetType: number;
  targetId: string;
  postCommentId?: number | null;
  targetTitle: string;
  targetOwnerUsername: string;
  targetOwnerTier: string;
  targetOwnerAmmoScore: number;
  targetOwnerFlagsAgainst: number;
  targetCanBeHidden: boolean;
  groupCount: number;
  reason: string;
  status: number;
  reviewedByUsername: string | null;
  reviewedAt: string | null;
  resolution: string | null;
  violationType: number;
  createdAt: string;
}

export const FlagStatus = { Open: 0, Resolved: 1, Dismissed: 2, Escalated: 3 } as const
export const FlagTargetType = {
  Post: 0,
  Comment: 1,
  Part: 2,
  FirearmModel: 3,
  Build: 4,
  PostComment: 5,
  SlopPost: 6
} as const

export const ResolveAction = {
  Dismiss: 'Dismiss',
  Warn: 'Warn',
  Remove: 'Remove',
  Escalate: 'Escalate'
} as const

export interface FlagListParams {
  status?: number | '';
  targetType?: string;
  dateFrom?: string;
  dateTo?: string;
}
